const shareProduct = (url, endpoint) => {
  window.open(`${url}${endpoint}`, "sharer", "toolbar=0,status=0,width=548,height=325");
};

export default shareProduct;
